import './Auth.css';
import linkedIn from '../../Assets/Images/RegisterPage/linkedin.png';
import google from '../../Assets/Images/RegisterPage/social.png';
import logo from '../../Assets/logo.png';
import bg from '../../Assets/Images/RegisterPage/background.png';

import visibleicon from '../../Assets/visible.png';


import { useNavigate, useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { RegisterCandidate, RegisterUserUsingEmail } from '../../services/auth';
import GoogleAuthentication from './GoogleAuth';

function Register(){
    const navigate = useNavigate();

    const [nameLabel,setNameLabel]=useState("");
    const [emailLabel,setEmailLabel]=useState("");
    const [phoneNumberLabel,setPhoneNumberLabel]=useState("");
    const [passwordLabel,setPasswordLabel]=useState("");
    const [cPasswordLabel,setCPasswordLabel]=useState("");

    const [error,setError]=useState('');
    
    const [googleAuth,setGoogleAuth]=useState(false);

    const [showPassword,setShowPassword]=useState(true);

    const [searchParams] = useSearchParams();
    const positionId = searchParams.get('positionId');
    const [positionDetails, setPositionDetails] = useState(null);
    const [loadingPosition, setLoadingPosition] = useState(false);

    // console.log(process.env.REACT_APP_ENV);
    // console.log(process.env.REACT_APP_API_URL);
    async function SaveForm(e)
    {
        e.preventDefault();
        var formData=new FormData(e.target);
        const data = Object.fromEntries(formData.entries());

        if(!data.name)
        {
                setNameLabel("Name Required!");
        }
        if(!data.email)
            {
                setEmailLabel("Email Required!");
            }
        if(!data.phoneNumber)
            {
                setPhoneNumberLabel("Phone Number Required!");
            }
        // if(!data.password)
        //     {
        //         setPasswordLabel("Password Required!");
        //     }

        if (!data.name || !data.email || !data.phoneNumber ) {
            return;
        }

        const newData={...data,positionId:positionId}
        
        const registered=await RegisterCandidate(newData);
   
        console.log('reg',registered);
        if(registered.data)
        {
            // navigate('/profilesetup');
            setError(registered.message);
            sessionStorage.clear();
            return;
        }
        else
        {
            setError(registered);
        }
    }
    const passwordRegex=/^(?=.*[A-Z])(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;
    

    return(
        <>
             <div className='registercontainer'>
                <div className='registerleft_part'>
                   <img src={logo} alt='logo' className='logo'/>
                   <img src={bg} alt='backgroundImage'/>
                </div>
                <div className='registerright_part'>
                     <span className='text'>
                        <h2>Register</h2>
                        <h3>Sign up with your email and password </h3>
                     </span>
                        <form onSubmit={(e)=>SaveForm(e)} >
                            <section className='inputsection'>
                                <div className="inputSubSection">
                                <h3>Full Name</h3>

                                <div className='inputfield'>
                                  <input type='text' name='name' placeholder="Enter your full name*" className='nameField'
                                    onChange={(e)=>{
                                    if(e.target.value!=="")
                                    {
                                        setNameLabel('');
                                    }}} />
                                      </div>
                                  <label className='nameLabel'>{nameLabel}</label>
                                </div>
                                <div className="inputSubSection">
                                 <h3>Phone Number</h3>
                                    <div className='inputfield'>
                                    <input type='text' name='phoneNumber' placeholder="Enter your phone number*" 
                                      onChange={(e)=>{
                                        if(e.target.value!=="")
                                        {
                                            setPhoneNumberLabel('');
                                        }}}/>
                                        </div>
                                    <label className='phoneNumberLabel'>{phoneNumberLabel}</label>
                                </div>
                                <div className="inputSubSection">
                                  <h3>Email</h3>
                                  <div className='inputfield'>
                                  <input type='email' name='email' placeholder="Enter your email*"
                                    onChange={(e)=>{
                                        if(e.target.value!=="")
                                        {
                                            setEmailLabel('');
                                        }}}/>
                                        </div>
                                  <label className='emailLabel'>{emailLabel}</label>
                                </div>
                                {/* <div className="inputSubSection">
                                       <h3>Password</h3>
                                  <div className='inputfield'>
                                  <input type={!showPassword?'text':'password'} name='password' placeholder="Password*"
                                  onChange={(e)=>{
                                    if(!passwordRegex.test(e.target.value))
                                    {
                                        setPasswordLabel('Password must include one Uppercase letter, one special character, and at least 8 characters long');
                                    }
                                    else
                                    {
                                        setPasswordLabel('');
                                    }
                                  }}
                                  />
                                    <img src={visibleicon} alt="show" className='showpassword' onPointerDown={()=>setShowPassword(prev=>!prev)} onPointerUp={()=>setShowPassword(prev=>!prev)}/>
                                    </div>
                                  <label className='passwordLabel'>{passwordLabel}</label>
                                </div> */}
                                {/* <div className="inputSubSection">
                                <input type='password' name='cpassword' placeholder="Confirm Password*"
                                  onChange={(e)=>{
                                    if(e.target.value!=="")
                                    {
                                        setCPasswordLabel('');
                                    }}}/>
                                
                                <label className='confirmPasswordLabel'>{cPasswordLabel}</label>
                                </div> */}
                                    <section className='registerbuttons'>
                                <label className='registererror'>{error}</label>
                                <button type="submit" className='registerbutton'>Register</button>
                                {/* <div className='orsection'>
                                    <hr  className="custom-hr"/>
                                        <h3>OR</h3>
                                    <hr  className="custom-hr"/>
                                </div>
                                <button className='continuephone' onClick={()=>navigate('/otpregister')}>CONTINUE WITH PHONE NUMBER</button> */}
                            </section>
                            </section>
                        
                            {/* <section className='socialsignin'>
                                <img src={linkedIn} alt='linkedIn' width="38" height="38"/>
                                <img src={google} onClick={()=>setGoogleAuth((prev)=>!prev)} alt='linkedIn' width="38" height="38" style={{filter:'grayscale(100%)'}}/>
                            </section> */}
                            {/* <h4> Already have an account ? <span onClick={()=>navigate('/login')}>Login</span></h4> */}
                    </form>
                </div>
                <div className={`googlecontainer ${googleAuth?'on':'off'}`}>
                                    <GoogleAuthentication/>
                                </div>
             </div>
        </>
        );

}

export default Register;